import React from "react";
import { IWebsiteBuilderSectionEntityViewBoundingBox } from "../../hooks/sectionEntity/helpers/sectionEntityViewBoundingBox";
import { WEBSITE_BUILDER_Z_LAYERS } from "../../../../utility/websiteBuilderZLayers";

interface ISectionEntityFrameResizeHandlesProps {
  selected: boolean;
  moving: boolean;
  boundingBox: IWebsiteBuilderSectionEntityViewBoundingBox;
  viewResizeHandles: JSX.Element;
}


export function SectionEntityFrameResizeHandles(props: ISectionEntityFrameResizeHandlesProps) {
  const { selected, moving, boundingBox, viewResizeHandles } = props;

  return (
    <>
      {selected && (
        <div
          className="website-builder-section-entity-frame-resize-handles-container"
          style={{
            left: boundingBox.x,
            top: boundingBox.y,
            width: boundingBox.width,
            height: boundingBox.height,
            zIndex: WEBSITE_BUILDER_Z_LAYERS.designSpace.sectionEntityOverride,
          }}
        >
          {!moving && viewResizeHandles}
        </div>
      )}
    </>
  );
}